import React, { useContext } from "react";
import { Button, Col, Container, Input, Label, Row } from "reactstrap";
import {
  THEME_UPDATE_MESSAGE,
  TextAlign,
  fontWeight,
} from "../../../../constant";
import ServiceCounterContext from "../../../context/ServiceCounterContext/ServiceCounterContext";
import ByteCardBuilderContext from "../../../context/BytecardBilderContext/ByteCardBuilderContext";
import LoaderContext from "../../../../context/LoaderContext/LoaderContext";
import { Switch } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { UploadCloud } from "react-feather";
import { Cases, DELETE_CONFIRM } from "../../../constant";
import { delete_Multi_Image_Permanent } from "../apis/SliderApi/SliderApi";
import { Zoom, toast } from "react-toastify";
import Dividers from "../../../common/divider";
import { OpenModalCommonFunc, TostMessage } from "../../../utils";
import { IconButton } from "@material-ui/core";
import ProductImageUploadPopup from "../../../Modals/imageUploade/productImageUploadPopup";
import CommonColor from "../../../common/CommonColor";
import CustomStyle from "../../../common/CustomStyle";
import { putUpdateServiceCounter } from "../apis/ServiceCounterApi/ServiceCounterApi";
import ServiceCounterTheme1 from "../ScreenShorts/ServiceCounter/ServiceCounterTheme1.png";
import ServiceCounterTheme3 from "../ScreenShorts/ServiceCounter/ServiceCounterTheme3.png";
import ServiceCounterTheme2 from "../ScreenShorts/ServiceCounter/ServiceCounterTheme2.png";
import ThemeImageShow from "../../../common/ThemeImageShow";

const ServiceCounterStyleThree = (props) => {
  const {
    isEdit,
    settingFormData,
    setSettingFormData,
    backImageToggle,
    setBackImageToggle,
    boxSection,
    setBoxSection,
    isBackgroundColor,
    setIsBackgroundColor,
    imageIs,
    setImageIs,
    setTheme,
    theme,
    id,
    imgShow,
    setImgShow,
  } = useContext(ServiceCounterContext);
  const {
    allPopupState,
    setAllPopupState,
    crop,
    setCrop,
    completedCrop,
    setCompletedCrop,
    scale,
    rotate,
  } = useContext(ByteCardBuilderContext);
  const { imageUpload, handleSubmitSetting, handleChangeSettings } = props;
  const { setLoaderShow } = useContext(LoaderContext);

  /**
   * input value change
   * @param {event} e
   */

  const handleChangCounterSection = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".counter3-section"]: {
          ...prev[".counter3-section"],
          [name]: value,
        },
      };
    });
  };
  const handleChangeCounterSectionBgImage = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".counter3-section.bg-image::before"]: {
          ...prev[".counter3-section.bg-image::before"],
          [name]: value,
        },
      };
    });
  };

  const handleChangCounterSectionTitleArea = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".counter3-section .section-title-area"]: {
          ...prev[".counter3-section .section-title-area"],
          [name]: value,
        },
      };
    });
  };

  const handleChangCounterSectionTitleAreaSubtitle = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".counter3-section .section-title-area .section-subtitle"]: {
          ...prev[".counter3-section .section-title-area .section-subtitle"],
          [name]: value,
        },
      };
    });
  };

  const handleChangCounterSectionTitleAreaTitle = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".counter3-section .section-title-area .section-title"]: {
          ...prev[".counter3-section .section-title-area .section-title"],
          [name]: value,
        },
      };
    });
  };

  const handleChangCounterSectionConutDiv = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".counter3-section .countdiv"]: {
          ...prev[".counter3-section .countdiv"],
          [name]: value,
        },
      };
    });
  };

  const handleChangCounterSectionCountDivCounter = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".counter3-section .countdiv .counter"]: {
          ...prev[".counter3-section .countdiv .counter"],
          [name]: value,
        },
      };
    });
  };

  const handleChangCounterSectionCountDivDivider = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".counter3-section .countdiv .divider"]: {
          ...prev[".counter3-section .countdiv .divider"],
          [name]: value,
        },
      };
    });
  };

  const handleChangCounterSectionCountDivCounterTitle = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".counter3-section .countdiv .counter-title"]: {
          ...prev[".counter3-section .countdiv .counter-title"],
          [name]: value,
        },
      };
    });
  };

  const handleChangeCustomStyle = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const resetHandler = () => {
    setSettingFormData({
      ".counter3-section": {
        padding: "100px 0",
        "background-color": { r: 0, g: 0, b: 0, a: 100 },
      },
      ".counter3-section.bg-image": {},
      ".counter3-section.bg-image::before": {
        // "background-color": { r: 0, g: 0, b: 0, a: 0.8 },
      },
      ".counter3-section .section-title-area": {
        "margin-bottom": "50px",
      },
      ".counter3-section .section-title-area .section-subtitle": {
        "font-size": "16px",
        "font-weight": "600",
        color: { r: 255, g: 73, b: 124, a: 100 },
        "background-color": { r: 255, g: 73, b: 124, a: 0.2 },
        padding: "5px 20px",
        p1: "5px",
        p2: "20px",
        "border-radius": "15px",
        "margin-bottom": "15px",
      },
      ".counter3-section .section-title-area .section-title": {
        "font-size": "44px",
        "font-weight": "600",
        color: { r: 255, g: 255, b: 255, a: 100 },
      },
      ".counter3-section .countdiv": {
        "text-align": "center",
        "margin-bottom": "30px",
      },
      ".counter3-section .countdiv .counter": {
        color: { r: 255, g: 73, b: 124, a: 100 },
        "font-size": "40px",
        "font-weight": "600",
      },
      ".counter3-section .countdiv .divider": {
        width: "80px",
        height: "4px",
        margin: "15px auto",
        "border-radius": "3px",
        "background-color": { r: 255, g: 255, b: 255, a: 100 },
      },
      ".counter3-section .countdiv .counter-title": {
        color: { r: 255, g: 255, b: 255, a: 100 },
        "font-size": "22px",
        "font-weight": "500",
      },
      serviceCounterId: "",
      custom: "",
    });
    setBackImageToggle(false);
    setBoxSection(false);
    setIsBackgroundColor(true);
  };

  /**
   * delete image permanently
   */
  const deleteImagePermanent = async () => {
    try {
      let confirmation = window.confirm(DELETE_CONFIRM);
      if (confirmation) {
        setLoaderShow(true);
        let formData = {
          fileName: settingFormData?.[".counter3-section.bg-image"]?.[
            "background-image"
          ]
            .split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER_MULTI}/`)
            .pop(),
        };
        const { data } = await delete_Multi_Image_Permanent(formData);
        if (data.status === 200) {
          toast.success(data.message, {
            autoClose: 1000,
            position: "top-center",
          });
          setSettingFormData({
            ...settingFormData,
            ".counter3-section.bg-image": { "background-image": "" },
          });
          setLoaderShow(false);
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message, {
        autoClose: 1000,
        transition: Zoom,
      });
      setLoaderShow(false);
    }
  };

  /**
   * image reupload
   */
  const reupload = () => {
    setSettingFormData((prev) => {
      return {
        ...prev,
        image: "",
      };
    });
  };

  const handleTheme = async (e) => {
    setLoaderShow(true);
    const { value } = e.target;
    setTheme(value);
    try {
      let formData = {
        theme: value,
        serviceCounterId: id,
      };
      const { data } = await putUpdateServiceCounter(formData);
      if (data.status === 200) {
        await handleChangeSettings(id, true);
        TostMessage({
          message: { message: THEME_UPDATE_MESSAGE },
          type: "success",
        });
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
    } finally {
      setLoaderShow(false);
    }
  };

  const handleClose = () => {
    setImgShow(false);
  };
  const themeImg = {
    1: ServiceCounterTheme1,
    2: ServiceCounterTheme2,
    3: ServiceCounterTheme3,
  };

  return (
    <>
      <Container className="mb-5">
        <Row>
          <Col sm="12" xl="12">
            <div className="mt-4 d-flex flex-column justify-content-center position-relative">
              <div
                className="d-flex justify-content-between position-sticky"
                style={{ top: "87px", background: "white", zIndex: 999 }}
              >
                <h6>{isEdit ? "Edit" : "Add New"}</h6>
                <div className="d-flex gap-2">
                  <Button onClick={resetHandler}>Reset</Button>
                  <Button onClick={() => handleSubmitSetting(true)}>
                    Restore
                  </Button>
                  <Button
                    onClick={() => handleSubmitSetting(null, false)}
                    color="success"
                  >
                    Save & View
                  </Button>
                </div>
              </div>
              <Row>
                <Col md="12 mb-3">
                  <label htmlFor="">Theme</label>
                  <select
                    name="theme"
                    id="font-weight"
                    className="form-select"
                    value={theme}
                    onChange={(e) => handleTheme(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  >
                    <option value={1}>Theme 1</option>
                    <option value={2}>Theme 2</option>
                    <option value={3}>Theme 3</option>
                  </select>
                </Col>
              </Row>
              {!imgShow && (
                <div>
                  <Button
                    onClick={() => setImgShow(true)}
                    color="primary"
                    className="mt-2"
                  >
                    Show Theme Image
                  </Button>
                </div>
              )}
              {imgShow && (
                <ThemeImageShow
                  themeImg={themeImg[theme]}
                  handleClose={handleClose}
                />
              )}
              <Row className="mt-4">
                <h4 className="mb-3">Make change in Main section</h4>
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Padding (default : 100)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="padding"
                    type="number"
                    placeholder="Padding"
                    value={settingFormData?.[".counter3-section"]?.["padding"]
                      ?.split(" ")[0]
                      ?.replace(/px/g, "")}
                    onChange={(e) => handleChangCounterSection(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
                <Col md="4 mb-3">
                  <div className="d-flex align-items-center">
                    <Label htmlFor="validationCustom03">
                      {isBackgroundColor
                        ? "Add Background Color"
                        : "Remove Background Color"}
                    </Label>
                    <Switch
                      checked={isBackgroundColor}
                      inputProps={{ "aria-label": "controlled" }}
                      onChange={(e) => {
                        setIsBackgroundColor(e.target.checked);
                        setSettingFormData((prev) => {
                          if (e.target.checked) {
                            if (boxSection) {
                              return {
                                ...prev,
                                [".counter3-section"]: {
                                  "background-color": "#000000",
                                  padding:
                                    settingFormData?.[".counter3-section"]?.[
                                      "padding"
                                    ],
                                  width: settingFormData?.[
                                    ".counter3-section"
                                  ]?.["width"]?.replace("rem)", ""),
                                  margin: settingFormData?.[
                                    ".counter3-section"
                                  ]?.["margin"]
                                    ?.split(" ")[0]
                                    ?.replace(/px/g, ""),
                                  "border-radius": settingFormData?.[
                                    ".counter3-section"
                                  ]?.["border-radius"]?.replace(/rem/g, ""),
                                },
                              };
                            } else {
                              return {
                                ...prev,
                                [".counter3-section"]: {
                                  "background-color": "#000000",
                                  padding:
                                    settingFormData?.[".counter3-section"]?.[
                                      "padding"
                                    ],
                                },
                              };
                            }
                          } else {
                            if (boxSection) {
                              return {
                                ...prev,
                                [".counter3-section"]: {
                                  padding:
                                    settingFormData?.[".counter3-section"]?.[
                                      "padding"
                                    ],
                                  width: settingFormData?.[
                                    ".counter3-section"
                                  ]?.["width"]?.replace("rem)", ""),
                                  margin: settingFormData?.[
                                    ".counter3-section"
                                  ]?.["margin"]
                                    ?.split(" ")[0]
                                    ?.replace(/px/g, ""),
                                  "border-radius": settingFormData?.[
                                    ".counter3-section"
                                  ]?.["border-radius"]?.replace(/rem/g, ""),
                                },
                              };
                            } else {
                              return {
                                ...prev,
                                [".counter3-section"]: {
                                  padding:
                                    settingFormData?.[".counter3-section"]?.[
                                      "padding"
                                    ],
                                },
                              };
                            }
                          }
                        });
                      }}
                    />
                  </div>
                  {isBackgroundColor && (
                    <CommonColor
                      color={
                        settingFormData?.[".counter3-section"]?.[
                          "background-color"
                        ]
                      }
                      setSettingFormData={setSettingFormData}
                      className={".counter3-section"}
                      classProperty={"background-color"}
                      label={"Select Background Color"}
                    />
                  )}
                </Col>
                <p>{"Box Section : convert your section to Box section"}</p>
                <div>
                  <Switch
                    checked={boxSection}
                    inputProps={{ "aria-label": "controlled" }}
                    onChange={(e) => {
                      setBoxSection(e.target.checked);
                      setSettingFormData((prev) => {
                        return {
                          ...prev,
                          ".counter3-section": {
                            padding: settingFormData?.[".counter3-section"]?.[
                              "padding"
                            ]
                              ?.split(" ")[0]
                              ?.replace(/px/g, ""),
                            "background-color":
                              settingFormData?.[".counter3-section"]?.[
                                "background-color"
                              ],
                            width: e.target.checked ? "10" : "",
                            margin: e.target.checked ? "0" : "",
                            "border-radius": e.target.checked ? "3" : "",
                          },
                        };
                      });
                    }}
                  />
                </div>
                {boxSection && (
                  <>
                    <Col md="4 mb-3">
                      <Label htmlFor="validationCustom03">
                        {"Width (Default : 10)"}
                      </Label>
                      <Input
                        className="form-control"
                        name="width"
                        type="number"
                        placeholder="width"
                        value={settingFormData?.[".counter3-section"]?.[
                          "width"
                        ]?.replace("rem)", "")}
                        onChange={(e) => handleChangCounterSection(e)}
                        style={{ borderRadius: "0", color: "black" }}
                      />
                    </Col>
                    <Col md="4 mb-3">
                      <Label htmlFor="validationCustom03">
                        {"Margin (Default : 0)"}
                      </Label>
                      <Input
                        className="form-control"
                        name="margin"
                        type="number"
                        placeholder="margin"
                        value={settingFormData?.[".counter3-section"]?.[
                          "margin"
                        ]
                          ?.split(" ")[0]
                          ?.replace(/px/g, "")}
                        onChange={(e) => handleChangCounterSection(e)}
                        style={{ borderRadius: "0", color: "black" }}
                      />
                    </Col>
                    <Col md="4 mb-3">
                      <Label htmlFor="validationCustom03">
                        {"Border Radius (Default : 3)"}
                      </Label>
                      <Input
                        className="form-control"
                        name="border-radius"
                        type="number"
                        placeholder="Border Radius"
                        value={settingFormData?.[".counter3-section"]?.[
                          "border-radius"
                        ]?.replace(/rem/g, "")}
                        onChange={(e) => handleChangCounterSection(e)}
                        style={{ borderRadius: "0", color: "black" }}
                      />
                    </Col>
                  </>
                )}
              </Row>
              <hr />
              <Row className="mt-4">
                <Col md="12 mb-3">
                  <h4 className="mb-3">Add Background Image in section</h4>

                  <p>do you want to upload Background image</p>
                  <Switch
                    checked={backImageToggle}
                    inputProps={{ "aria-label": "controlled" }}
                    onChange={(e) => {
                      setBackImageToggle(e.target.checked);
                      setSettingFormData((prev) => {
                        if (e.target.checked) {
                          return {
                            ...prev,
                            image: "",
                            ".counter3-section.bg-image": {},
                            ".counter3-section.bg-image::before": {
                              "background-color": { r: 0, g: 0, b: 0, a: 0.8 },
                            },
                          };
                        } else {
                          return {
                            ...prev,
                            image: "",
                            ".counter3-section.bg-image": {},
                            ".counter3-section.bg-image::before": {},
                          };
                        }
                      });
                    }}
                  />
                  {backImageToggle && (
                    <>
                      {" "}
                      <Col md="6 mb-3">
                        <Dividers divide="IMAGE" />
                        <p className="mb-4">
                          File type required JPG, PNG (1905px X 485px)
                        </p>
                      </Col>
                      <Row>
                        <Col md="4 mb-3">
                          <div
                            className="aj-uploader d-flex flex-wrap  justify-content-center  align-items-center"
                            style={{ cursor: "pointer" }}
                          >
                            {!settingFormData?.[".counter3-section.bg-image"]?.[
                              "background-image"
                            ] && (
                              <span
                                onClick={() => {
                                  OpenModalCommonFunc(
                                    Cases.PRODUCT_UPLOAD,
                                    setAllPopupState
                                  );
                                  setImageIs("serImage3");
                                }}
                              >
                                <UploadCloud />
                              </span>
                            )}

                            {settingFormData?.[".counter3-section.bg-image"]?.[
                              "background-image"
                            ] && (
                              <img
                                src={
                                  settingFormData?.[
                                    ".counter3-section.bg-image"
                                  ]?.["background-image"] || ""
                                }
                                alt=""
                                style={{
                                  width: "85%",
                                  height: "90px",
                                  objectFit: "contain",
                                  position: "absolute",
                                }}
                                onClick={() => deleteImagePermanent()}
                              />
                            )}
                            {settingFormData?.[".counter3-section.bg-image"]?.[
                              "background-image"
                            ] && (
                              <IconButton
                                edge="start"
                                color="inherit"
                                aria-label="close"
                                style={{
                                  color: "red",
                                  position: "absolute",
                                  top: "-22px",
                                  left: "1px",
                                }}
                                onClick={() => deleteImagePermanent()}
                              >
                                <Close
                                  style={{
                                    fontSize: "25px",
                                    fontWeight: "bold",
                                  }}
                                />
                              </IconButton>
                            )}
                          </div>
                        </Col>
                        <Col md="6 mb-3">
                          <h4 className="mb-3">
                            Add Background color in section
                          </h4>
                          <Col md="6 mb-3">
                            <CommonColor
                              color={
                                settingFormData?.[
                                  ".counter3-section.bg-image::before"
                                ]?.["background-color"]
                              }
                              setSettingFormData={setSettingFormData}
                              className={".counter3-section.bg-image::before"}
                              classProperty={"background-color"}
                              label={"Select Background Color"}
                            />
                          </Col>
                        </Col>
                      </Row>
                    </>
                  )}
                </Col>
              </Row>
              <hr />
              <Row className="mt-4">
                <h4 className="mb-3">Make space in Title bottom</h4>
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Margin Bottom (Default : 50)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="margin-bottom"
                    type="number"
                    placeholder="Margin Bottom"
                    value={settingFormData?.[
                      ".counter3-section .section-title-area"
                    ]?.["margin-bottom"]?.replace(/px/g, "")}
                    onChange={(e) => handleChangCounterSectionTitleArea(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
              </Row>
              <hr />
              <Row className="mt-4">
                <h4 className="mb-3">Make change in section subtitle</h4>
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Font Size (Default : 16)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="font-size"
                    type="number"
                    placeholder="Font Size"
                    value={settingFormData?.[
                      ".counter3-section .section-title-area .section-subtitle"
                    ]?.["font-size"]?.replace(/px/g, "")}
                    onChange={(e) =>
                      handleChangCounterSectionTitleAreaSubtitle(e)
                    }
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Font Weight (Default : 600)"}
                  </Label>
                  <select
                    name="font-weight"
                    id="font-weight"
                    className="form-select"
                    value={
                      settingFormData?.[
                        ".counter3-section .section-title-area .section-subtitle"
                      ]?.["font-weight"]
                    }
                    onChange={(e) =>
                      handleChangCounterSectionTitleAreaSubtitle(e)
                    }
                    style={{ borderRadius: "0", color: "black" }}
                  >
                    <option value="">--select--</option>
                    {fontWeight.map((elem) => {
                      return (
                        <option value={elem["font-weight"]}>
                          {elem["font-weight"]}
                        </option>
                      );
                    })}
                  </select>
                </Col>
                <Col md="3 mb-3">
                  <CommonColor
                    color={
                      settingFormData?.[
                        ".counter3-section .section-title-area .section-subtitle"
                      ]?.["color"]
                    }
                    setSettingFormData={setSettingFormData}
                    className={
                      ".counter3-section .section-title-area .section-subtitle"
                    }
                    classProperty={"color"}
                    label={"Select Color"}
                  />
                </Col>
                <Col md="3 mb-3">
                  <CommonColor
                    color={
                      settingFormData?.[
                        ".counter3-section .section-title-area .section-subtitle"
                      ]?.["background-color"]
                    }
                    setSettingFormData={setSettingFormData}
                    className={
                      ".counter3-section .section-title-area .section-subtitle"
                    }
                    classProperty={"background-color"}
                    label={"Select Background Color"}
                  />
                </Col>
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Padding (Default : 5 - 20)"}
                  </Label>
                  <div className="d-flex justify-content-between">
                    <Input
                      className="form-control"
                      name="p1"
                      type="number"
                      placeholder="Padding"
                      value={settingFormData?.[
                        ".counter3-section .section-title-area .section-subtitle"
                      ]?.["p1"]?.replace(/px/g, "")}
                      onChange={(e) =>
                        handleChangCounterSectionTitleAreaSubtitle(e)
                      }
                      style={{ borderRadius: "0", color: "black" }}
                    />
                    <Input
                      className="form-control"
                      name="p2"
                      type="number"
                      placeholder="Padding"
                      value={settingFormData?.[
                        ".counter3-section .section-title-area .section-subtitle"
                      ]?.["p2"]?.replace(/px/g, "")}
                      onChange={(e) =>
                        handleChangCounterSectionTitleAreaSubtitle(e)
                      }
                      style={{ borderRadius: "0", color: "black" }}
                    />
                  </div>
                </Col>
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Border Radius (Default : 15)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="border-radius"
                    type="number"
                    placeholder="Border Radius"
                    value={settingFormData?.[
                      ".counter3-section .section-title-area .section-subtitle"
                    ]?.["border-radius"]?.replace(/px/g, "")}
                    onChange={(e) =>
                      handleChangCounterSectionTitleAreaSubtitle(e)
                    }
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Margin Bottom (Default : 15)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="margin-bottom"
                    type="number"
                    placeholder="Margin Bottom"
                    value={settingFormData?.[
                      ".counter3-section .section-title-area .section-subtitle"
                    ]?.["margin-bottom"]?.replace(/px/g, "")}
                    onChange={(e) =>
                      handleChangCounterSectionTitleAreaSubtitle(e)
                    }
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
              </Row>
              <hr />
              <Row className="mt-4">
                <h4 className="mb-3">Make change in section Title</h4>
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Font Size (Default : 44)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="font-size"
                    type="number"
                    placeholder="Font Size"
                    value={settingFormData?.[
                      ".counter3-section .section-title-area .section-title"
                    ]?.["font-size"]?.replace(/px/g, "")}
                    onChange={(e) => handleChangCounterSectionTitleAreaTitle(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Font Weight (Default : 600)"}
                  </Label>
                  <select
                    name="font-weight"
                    id="font-weight"
                    className="form-select"
                    value={
                      settingFormData?.[
                        ".counter3-section .section-title-area .section-title"
                      ]?.["font-weight"]
                    }
                    onChange={(e) => handleChangCounterSectionTitleAreaTitle(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  >
                    <option value="">--select--</option>
                    {fontWeight.map((elem) => {
                      return (
                        <option value={elem["font-weight"]}>
                          {elem["font-weight"]}
                        </option>
                      );
                    })}
                  </select>
                </Col>
                <Col md="3 mb-3">
                  <CommonColor
                    color={
                      settingFormData?.[
                        ".counter3-section .section-title-area .section-title"
                      ]?.["color"]
                    }
                    setSettingFormData={setSettingFormData}
                    className={
                      ".counter3-section .section-title-area .section-title"
                    }
                    classProperty={"color"}
                    label={"Select Color"}
                  />
                </Col>
              </Row>
              <hr />
              <Row className="mt-4">
                <h4 className="mb-3">Make change in section count div</h4>
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Text Align (Default : center)"}
                  </Label>
                  <select
                    name="text-align"
                    id="text-align"
                    className="form-select"
                    value={
                      settingFormData?.[".counter3-section .countdiv"]?.[
                        "text-align"
                      ]
                    }
                    onChange={(e) => handleChangCounterSectionConutDiv(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  >
                    <option value="">--select--</option>
                    {TextAlign.map((elem) => {
                      return (
                        <option value={elem["text-align"]}>
                          {elem["text-align"]}
                        </option>
                      );
                    })}
                  </select>
                </Col>
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Margin bottom (Default : 30)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="margin-bottom"
                    type="number"
                    placeholder="Margin bottom"
                    value={settingFormData?.[".counter3-section .countdiv"]?.[
                      "margin-bottom"
                    ]?.replace(/px/g, "")}
                    onChange={(e) => handleChangCounterSectionConutDiv(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
              </Row>
              <hr />
              <Row className="mt-4">
                <h4 className="mb-3">
                  Make change in section count div counter
                </h4>
                <Col md="3 mb-3">
                  <CommonColor
                    color={
                      settingFormData?.[
                        ".counter3-section .countdiv .counter"
                      ]?.["color"]
                    }
                    setSettingFormData={setSettingFormData}
                    className={".counter3-section .countdiv .counter"}
                    classProperty={"color"}
                    label={"Select Color"}
                  />
                </Col>
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Font Size (Default : 40)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="font-size"
                    type="number"
                    placeholder="Font Size"
                    value={settingFormData?.[
                      ".counter3-section .countdiv .counter"
                    ]?.["font-size"]?.replace(/px/g, "")}
                    onChange={(e) =>
                      handleChangCounterSectionCountDivCounter(e)
                    }
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Font Weight (Default : 600)"}
                  </Label>
                  <select
                    name="font-weight"
                    id="font-weight"
                    className="form-select"
                    value={
                      settingFormData?.[
                        ".counter3-section .countdiv .counter"
                      ]?.["font-weight"]
                    }
                    onChange={(e) =>
                      handleChangCounterSectionCountDivCounter(e)
                    }
                    style={{ borderRadius: "0", color: "black" }}
                  >
                    <option value="">--select--</option>
                    {fontWeight.map((elem) => {
                      return (
                        <option value={elem["font-weight"]}>
                          {elem["font-weight"]}
                        </option>
                      );
                    })}
                  </select>
                </Col>
              </Row>
              <hr />
              <Row className="mt-4">
                <h4 className="mb-3">Make change in count div divider</h4>
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Width (Default : 80)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="width"
                    type="number"
                    placeholder="Width"
                    value={settingFormData?.[
                      ".counter3-section .countdiv .divider"
                    ]?.["width"]?.replace(/px/g, "")}
                    onChange={(e) =>
                      handleChangCounterSectionCountDivDivider(e)
                    }
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Height (Default : 4)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="height"
                    type="number"
                    placeholder="Height"
                    value={settingFormData?.[
                      ".counter3-section .countdiv .divider"
                    ]?.["height"]?.replace(/px/g, "")}
                    onChange={(e) =>
                      handleChangCounterSectionCountDivDivider(e)
                    }
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"margin (Default : 15)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="margin"
                    type="number"
                    placeholder="margin"
                    value={settingFormData?.[
                      ".counter3-section .countdiv .divider"
                    ]?.["margin"]
                      ?.split(" ")[0]
                      ?.replace(/px/g, "")}
                    onChange={(e) =>
                      handleChangCounterSectionCountDivDivider(e)
                    }
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Border Radius (Default : 3)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="border-radius"
                    type="number"
                    placeholder="Border Radius"
                    value={settingFormData?.[
                      ".counter3-section .countdiv .divider"
                    ]?.["border-radius"]?.replace(/px/g, "")}
                    onChange={(e) =>
                      handleChangCounterSectionCountDivDivider(e)
                    }
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
                <Col md="3 mb-3">
                  <CommonColor
                    color={
                      settingFormData?.[
                        ".counter3-section .countdiv .divider"
                      ]?.["background-color"]
                    }
                    setSettingFormData={setSettingFormData}
                    className={".counter3-section .countdiv .divider"}
                    classProperty={"background-color"}
                    label={"Select Background Color"}
                  />
                </Col>
              </Row>
              <hr />
              <Row className="mt-4">
                <h4 className="mb-3">Make change in counter title</h4>
                <Col md="3 mb-3">
                  <CommonColor
                    color={
                      settingFormData?.[
                        ".counter3-section .countdiv .counter-title"
                      ]?.["color"]
                    }
                    setSettingFormData={setSettingFormData}
                    className={".counter3-section .countdiv .counter-title"}
                    classProperty={"color"}
                    label={"Select Color"}
                  />
                </Col>
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Font Size (Default : 22)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="font-size"
                    type="number"
                    placeholder="Font Size"
                    value={settingFormData?.[
                      ".counter3-section .countdiv .counter-title"
                    ]?.["font-size"]?.replace(/px/g, "")}
                    onChange={(e) =>
                      handleChangCounterSectionCountDivCounterTitle(e)
                    }
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Font Weight (Default : 500)"}
                  </Label>
                  <select
                    name="font-weight"
                    id="font-weight"
                    className="form-select"
                    value={
                      settingFormData?.[
                        ".counter3-section .countdiv .counter-title"
                      ]?.["font-weight"]
                    }
                    onChange={(e) =>
                      handleChangCounterSectionCountDivCounterTitle(e)
                    }
                    style={{ borderRadius: "0", color: "black" }}
                  >
                    <option value="">--select--</option>
                    {fontWeight.map((elem) => {
                      return (
                        <option value={elem["font-weight"]}>
                          {elem["font-weight"]}
                        </option>
                      );
                    })}
                  </select>
                </Col>
              </Row>
              <CustomStyle
                handleChange={handleChangeCustomStyle}
                value={settingFormData?.custom}
              />
            </div>
          </Col>
        </Row>
        <ProductImageUploadPopup
          allPopupState={allPopupState}
          setAllPopupState={setAllPopupState}
          crop={crop}
          setCrop={setCrop}
          completedCrop={completedCrop}
          setCompletedCrop={setCompletedCrop}
          scale={scale}
          rotate={rotate}
          image={settingFormData?.image}
          setImage={setSettingFormData}
          imageUpload={imageUpload}
          isEdit={isEdit}
          reupload={reupload}
          // aspect={3.93 / 1}
        />
      </Container>
    </>
  );
};

export default ServiceCounterStyleThree;
